'use client';

import { Tabs } from '@/components/core';
import { Trans } from '@lingui/react/macro';
import InternalLink from '@/components/core/components/organism/internal-link';
import { usePathname } from 'next/navigation';
import React from 'react';
import { UserType } from '@/@types';
import { useLocalizedLinks } from '@/components/core/hooks';

const ProfileTabs: React.FC<{ user: UserType; hideMap?: boolean }> = ({ user, hideMap }) => {
  const pathname = usePathname();
  const links = useLocalizedLinks();

  return (
    <Tabs activeTab={pathname} data-active={pathname}>
      <Tabs.Tab name={links.profile(user).root} as={InternalLink} href={links.profile(user).root}>
        <Trans>Collections</Trans>
      </Tabs.Tab>
      <Tabs.Tab name={links.profile(user).activity} as={InternalLink} href={links.profile(user).activity}>
        <Trans>Activity</Trans>
      </Tabs.Tab>
      {!hideMap && (
        <Tabs.Tab name={links.profile(user).map} as={InternalLink} href={links.profile(user).map}>
          <Trans>Map</Trans>
        </Tabs.Tab>
      )}
    </Tabs>
  );
};

export default ProfileTabs;
